<div class="contact-quick-information" [ngClass]="class">
  <div class="contact-quick-information-field"><span class="pii">{{ contact.fullName }}</span></div>

  <div class="contact-quick-information-field" *ngIf="contact.email">
    <a draggable="false" href="mailto:{{ contact.email }}"><span class="pii">{{ contact.email }}</span></a>
  </div>

  <div class="contact-quick-information-field" *ngIf="contact.phone">
    <a draggable="false" href="tel:{{ formattedPhone }}">{{ formattedPhone }}</a>
  </div>
</div>
